module.exports = __webpack_public_path__ + "static/media/right.9ca47b55.svg";